// extracted by mini-css-extract-plugin
export var container = "_5g-0";
export var error = "_5g-9";
export var label = "_5g-5";
export var light = "_5g-6";
export var md = "_5g-3";
export var sm = "_5g-2";
export var thin = "_5g-8";
export var thinBold = "_5g-7";
export var vertical = "_5g-4";
export var xs = "_5g-1";